import { css, html, nothing } from "lit";
import { ifDefined } from "lit-html/directives/if-defined.js";
import "../../atom/Icon/index.js";
import "../../atom/Count/index.js";
import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { getButtonClasses, getIconClasses } from "./utils.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfIconButton = class extends BaseComponent {
  constructor() {
    super();
    this.dsf_size = "medium";
    this.dsf_level = "neutral";
    this.disabled = false;
    this.dsf_notification_count = 0;
    this.dsf_notification_indicator = false;
    this.onElementClick = this.onElementClick.bind(this);
    this.addEventListener("click", this.onElementClick, { capture: true });
  }
  onElementClick(event) {
    if (this.disabled) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }
  render() {
    const buttonClasses = getButtonClasses(this);
    const iconClasses = getIconClasses(this);
    return html`
      <button
        class="${buttonClasses}"
        ?disabled="${this.disabled}"
        type="button"
        role="button"
        title=${ifDefined(this.dsf_title)}
        part="button"
        data-skeleton
      >
        ${this.dsf_icon ? html`<dsf-icon dsf_name="${this.dsf_icon}" class=${iconClasses}></dsf-icon>` : nothing}
        ${this.dsf_notification_count > 0 ? html`<dsf-count
              dsf_count=${this.dsf_notification_count}
              class="absolute -top-2 left-[80%]"
              data-notification-count
            ></dsf-count>` : nothing}
        ${this.dsf_notification_indicator && this.dsf_notification_count <= 0 ? html`<div
              class="absolute right-0 top-0 h-6 w-6 rounded-full bg-error-300"
              data-skeleton
              data-notification-indicator
            ></div>` : nothing}
      </button>
    `;
  }
};
DsfIconButton.styles = [
  ...BaseComponent.styles,
  css`
      :host {
        display: inline-flex;
      }

      button[disabled] * {
        pointer-events: none;
      }
    `
];
__decorateClass([
  prop({ type: String, reflect: true })
], DsfIconButton.prototype, "dsf_size", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfIconButton.prototype, "dsf_level", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfIconButton.prototype, "disabled", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfIconButton.prototype, "dsf_icon", 2);
__decorateClass([
  prop({ type: String })
], DsfIconButton.prototype, "dsf_title", 2);
__decorateClass([
  prop({ type: Number })
], DsfIconButton.prototype, "dsf_notification_count", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfIconButton.prototype, "dsf_notification_indicator", 2);
DsfIconButton = __decorateClass([
  defineElement("dsf-icon-button")
], DsfIconButton);
export {
  DsfIconButton
};
